import { useApplication } from '@/hooks/useApplication';
import { ConfigurationVariable } from '@/types/metadata/metadata';
import { semaphoreUtil } from '@/util/validation/semaphore';
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { FC } from 'react';
import { ParamProps } from './ParamRenderer';

const ParamSemaphore: FC<ParamProps> = (props) => {
  const configuration = props.configuration as ConfigurationVariable;
  const { application } = useApplication();

  const initialValue = semaphoreUtil().getValue(props.configuration, props.initialValue);

  const semaphores = application?.semaphores || [];

  const handleChange = (event: SelectChangeEvent) => {
    props.onChange([props.configuration.value, parseInt(event.target.value, 10)]);
  };

  return (
    <FormControl fullWidth size='small' required={props.configuration.required}>
      <InputLabel id='select-semaphore-label'>{configuration.label}</InputLabel>
      <Select
        labelId='select-semaphore-label'
        id='select-semaphore'
        value={initialValue?.toString() || ''}
        label={configuration.label}
        onChange={handleChange}
        required={props.configuration.required}
        error={!!props.errors?.length}
      >
        {initialValue && <MenuItem key={`semaphore ${0}`} value={undefined} sx={{ height: 30 }} />}
        {semaphores
          .sort((semaphoreA, semaphoreB) => semaphoreA.name.localeCompare(semaphoreB.name))
          .map((semaphore) => (
            <MenuItem key={`semaphore ${semaphore.id}`} value={semaphore.id}>
              {semaphore.name}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
};

export default ParamSemaphore;
